import { EventType } from "../../models/History";
import { TaskType } from "../pages/tasks/tasks-table-item/tasks-table-item.component";

const taskTypeName = new Map<TaskType, string>([
  [TaskType.RECEIVING, "Recebimento"],
  [TaskType.RECEIVE, "Recebimento"],
  [TaskType.DISPATCHING, "Expedição"],
  [TaskType.DISPATCH, "Expedição"],
  [TaskType.LOAD_DISPATCH, "Saída"],
  [TaskType.RELOCATE_STORAGE, "Movimentação"],
  [TaskType.RELOCATE_POSITION, "Movimentação"],
  [TaskType.RELOCATE_EXPEDITION, "Movimentação"],
  [TaskType.RELOCATE_DIVERGENT, "Movimentação"],
  [TaskType.RELOCATE_QUALITY, "Movimentação"],
  [TaskType.RELOCATE_DOCK, "Movimentação"],
  [TaskType.RELOCATE_FREE, "Movimentação Livre"],
  [TaskType.RELOCATE_FROM_PICKING, "Realocação para separação"],
  [TaskType.RELOCATE_BY_HANDSCANNER, "Movimentação pelo coletor"],
  [TaskType.INVENTORY_BY_GROUND_POSITION_GROUP, "Inventário por setor"],
  [TaskType.INVENTORY_BY_PRODUCT, "Inventário por produto"],
  [TaskType.INVENTORY_BY_TAG_RFID, "Inventário por tag RFID"],
  [TaskType.INVENTORY_BY_GROUND_POSITION, "Inventário por posição"],
  [TaskType.PRODUCT_INVENTORY_BY_CRATE_TAG_RFID, "Inventário por pallet"],
  [TaskType.INVENTORY_BY_MISSING_CRATE, "Inventário por pallet perdido"],
  [TaskType.INVENTORY_BY_PIGEONHOLE_POSITION, "Inventário por escaninho"],
  [TaskType.PRODUCT_PICKING, "Separação de produto"],
  [TaskType.PICKING, "Separação"],
  [TaskType.EDIT_PALLET, "Edição de Pallet"],
  [TaskType.EXIT_BY_GROUND_POSITION, "Saída por posição"],
  [TaskType.EXIT_MISSING_PALLETS, "Saída por inventário"],
  [TaskType.RECEIVE_WITH_IN_ORDER, "Recebimento com Ordem de Entrada"],
  [TaskType.CREATE_CRATE, "Recebimento direto no estoque"],
  [TaskType.TAKE_SOME_PRODUCTS_TO_EXIT, "Expedição fracionada"],
  [TaskType.PALLET_MANAGEMENT, "Gerenciamento de Pallets"],
  [TaskType.PACKING, "Separação"],
  [TaskType.PALLET_TRANSFER, "Transferência entre Pallets"]
]);

const eventTypeName = new Map<EventType, string>([
  [EventType.FOUND, "Encontrado por inventário"],
  [EventType.FOUND_MISPLACED, "Encontrado em lugar indevido"],
  [EventType.MISSING, "Perdido por inventário"],
  [EventType.LOAD, "Início de movimentação"],
  [EventType.UNLOAD, "Fim de movimentação"],
  [EventType.EXIT, "Saída"],
  [EventType.ENTRY, "Entrada"],
  [EventType.EDIT_PRODUCT, "Edição de Produtos"],
  [EventType.UNLOAD_NOT_CONFIRMED, "Fim da Movimentação Não Confirmada"],
  [EventType.EDITED_UNLOAD, "Fim da Movimentação Editada"],
  [EventType.SET_UNDER_ALERT, "Bloqueio de Pallet"],
  [EventType.UNSET_UNDER_ALERT, "Desbloqueio de Pallet"],
  [EventType.LINKED_OUT_ORDER, "Vinculado a Ordem de Saída"],
  [EventType.UNLINKED_OUT_ORDER, "Desvinculado da Ordem de Saída"],
  [EventType.TRANSFER_IN, "Transferência de Produtos"],
  [EventType.TRANSFER_OUT, "Transferência de Produtos"],
  [EventType.FINISH, "Conclusão da Conferência"],
  [EventType.START_WITHOUT_OUT_ORDER, "Início da Conferência sem Ordem de Saída"],
  [EventType.START_WITH_OUT_ORDER, "Início da Conferência com Ordem de Saída"],
  [EventType.CANCEL, "Cancelamento da Conferência"]
]);

export function getTaskTypeName(taskType: TaskType, eventType?: EventType): string {
  if (taskType === TaskType.PACKING) {
    if (eventType && eventType === EventType.LINKED_OUT_ORDER) return "Separação";
    if (eventType && eventType === EventType.UNLINKED_OUT_ORDER) return "Separação Retornada";
  }

  return taskTypeName.get(taskType) || "---";
}

export function getEventTypeName(eventType: EventType): string {
  return eventTypeName.get(eventType) || "---";
}
